import { IFaq } from '../interfaces/i-faq';

export const FAQ: IFaq[] = [
  {
    text: 'Como faço para baixar um cupom no app do mobo?',
    faqAnswers: [
      {
        text: 'Escolha a oferta desejada',
      },
      {
        text: 'Baixar Cupom',
      },
      {
        text: 'Neste momento o cupom é seu e poderá ser visto na área "Pedidos" e expira até as 06:00h ou enquanto durarem as promoções',
      },
      {
        text: 'O processo é simples, rápido e você não precisa pagar nada antes de usar',
      },
      {
        text: 'Informe o código ou o nome cadastrado no app no momento do pagamento, o restaurante irá validar o seu desconto imediatamente',
      },
      {
        text: 'Não é possível baixar mais de um cupom do mesmo estabelecimento por conta, mas você pode baixar cupons de diferentes pratos do mesmo estabelecimento',
      },
    ],
  },
  {
    text: 'Eu pago algo dentro do app do mobo?',
    faqAnswers: [
      {
        text: 'O processo de pagamento é feito diretamente no estabelecimento, apenas disponibilizamos as melhores promoções para você',
      },
    ],
  },
  {
    text: 'Quantos cupons eu posso comprar na mesma oferta?',
    faqAnswers: [
      {
        text: 'Só é possível baixar um cupom da mesma oferta por conta',
      },
      {
        text: 'Caso você deseje compartilhar o cupom com seus familiares e amigos, disponibilizaremos ferramentas de compartilhamento para facilitar',
      },
      {
        text: 'Porém é possível baixar um cupom de cada campanha, no mesmo estabelecimento',
      },
    ],
  },
  {
    text: 'Após baixado, por quanto tempo o meu cupom fica disponível para validação?',
    faqAnswers: [
      {
        text: 'O cupom já baixado ficará disponível na área de "Pedidos" e expira até as 06:00h ou enquanto durarem as promoções',
      },
    ],
  },
  {
    text: 'Como faço para cancelar um cupom baixado ou validado?',
    faqAnswers: [
      {
        text: 'O cancelamento pode ser feito imediatamente após baixar o cupom, na própria tela da promoção',
      },
      {
        text: 'Também é possível cancelar o cupom acessando a área "Pedidos" no app',
      },
      {
        text: 'Cupons não utilizados serão cancelados automaticamente até às 6h do dia seguinte ou enquanto durarem as promoções',
      },
    ],
  },
  {
    text: 'Existe algum outro meio de validar meu código?',
    faqAnswers: [
      {
        text: 'Para facilitar o processo estabelecimento pode validar o seu cupom diretamente no próprio sistema, será necessário apenas informar o nome do usuário do app',
      },
    ],
  },
  {
    text: 'É preciso estar no estabelecimento para baixar o cupom?',
    faqAnswers: [
      {
        text: 'Não é necessário estar no estabelecimento para baixar e para validar o cupom',
      },
      {
        text: 'Podendo assim ser baixado alguns dias anteriores a uma viagem',
      },
      {
        text: 'Ou gerar o código para delivery',
      },
    ],
  },
  {
    text: 'Não poderei utilizar a campanha no prazo desejado, tem como eu adquiri-la novamente?',
    faqAnswers: [
      {
        text: 'Sim! É possível baixar novamente a campanha imediatamente, desde que não haja nenhum cupom ativo vinculado à mesma promoção.',
      },
    ],
  },
  {
    text: 'Como recebo meu cupom?',
    faqAnswers: [
      {
        text: 'O cupom é um código digital, após baixado você poderá verificá-lo na área de "Pedidos"',
      },
      {
        text: 'Para acessar a área de "Pedidos", selecione o item "Pedidos" na barra de menu inferior',
      },
      {
        text: 'Nessa área você pode visualizar os seus cupons e pedidos de delivery',
      },
    ],
  },
  {
    text: 'Não estou conseguindo visualizar meu cupom. Como proceder?',
    faqAnswers: [
      {
        text: 'Verifique se você baixou os seus cupons procurando por ele em "Pedidos"',
      },
      {
        text: 'Caso você não ache o cupom existe a possibilidade de a promoção ter terminado ou ter sido desativada pelo estabelecimento',
      },
      {
        text: 'Se esse for o caso, teremos outras incríveis promoções à sua disposição, para você comer bem pagando menos!',
      },
    ],
  },
  {
    text: 'Validei meu cupom antes da hora e perdi meu código, como faço para recupera-lo?',
    faqAnswers: [
      {
        text: 'Verifique se você baixou os seus cupons procurando por ele na barra "Procura"',
      },
    ],
  },
  {
    text: 'Como faço para anunciar meu restaurante no Mobo?',
    faqAnswers: [
      {
        text: 'Acesse o site Mobo',
      },
      {
        text: 'Clique em "Parceiro Mobo"',
      },
      {
        text: 'Inicie o processo de cadastro de sua empresa',
      },
      {
        text: 'Escolha a forma de pagamento que mais de adeque as suas preferências',
      },
      {
        text: 'Crie sua primeira campanha e já comece a utilizar',
      },
    ],
  },
];
